import { Globals } from 'src/app/services/globals';
import { SaveService } from './save.service';
import { ContactDetails } from './../shared/model/save.model';
import { AppConstants } from 'src/app/app.constants';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { DigitalSignature,  SignDocument, Definition, Signataire, ReplyTo, Body } from './../module/signature/model/digitalSignature.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DigitalSignatureService {

  public digitalSignature:DigitalSignature;

  public signature:Signataire;

  constructor(private http:HttpClient,private saveService:SaveService,private globals:Globals) {

    this.digitalSignature=new DigitalSignature();
   
    this.signature=new Signataire();
   } 
  
   validateDigitalSignature(Request: any){
    // var contactDetails = this.saveService.getContactDetails();

    //  this.signature.EMail=contactDetails.EmailAddress;
    //   this.signature.FirstName=contactDetails.FirstName;
    //   this.signature.LastName=contactDetails.LastName;
    //   this.signature.Language=this.globals.languagecode;

    //   this.digitalSignature.Signataire=this.signature;
    //   this.digitalSignature.FniceNo = fniceNo;

      return this.http.post<any>(environment.apiURL + AppConstants.APIURLS.ValidateDigitalSignature, Request);

   }   
}
